(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["floating-cart-button"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var sectionId = '{{ section.id }}';
    var root = document.getElementById('floating-cart-' + sectionId);
    if (!root) return;

    function formatMoney(cents) {
      // Usa la función nativa de Shopify si existe
      try {
        if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
          var moneyFormat = (window.theme && window.theme.moneyFormat) || '{{ shop.money_format | json }}';
          return Shopify.formatMoney(cents, moneyFormat);
        }
      } catch (e) {}

      // Fallback simple
      var value = (cents / 100).toFixed(2);
      return value;
    }

    function updateFloatingCart() {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function(res) { return res.json(); })
        .then(function(cart) {
          var totalEl = root.querySelector('.floating-cart-total');
          var countEl = root.querySelector('.floating-cart-count');

          if (totalEl) {
            totalEl.textContent = formatMoney(cart.total_price);
          }
          if (countEl) {
            countEl.textContent = '(' + cart.item_count + ')';
          }
        })
        .catch(function(e) {
          console.warn('Floating cart update failed', e);
        });
    }

    // 1) Actualizar al cargar
    document.addEventListener('DOMContentLoaded', function() {
      updateFloatingCart();
    });

    // 2) Escuchar eventos personalizados de algunos themes (Dawn y similares)
    document.addEventListener('cart:updated', function() {
      updateFloatingCart();
    });

    // 3) Detectar envíos de formularios /cart/add (fallback genérico)
    document.body.addEventListener('submit', function(e) {
      var form = e.target;
      if (!form || !form.matches('form[action*="/cart/add"]')) return;

      // Esperar a que el theme haga la llamada AJAX y luego refrescar
      setTimeout(updateFloatingCart, 700);
    }, true);

    // 4) Detectar clicks en botones con atributo data-add-to-cart común
    document.body.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-add-to-cart], [name="add"], .product-form__submit');
      if (!btn) return;
      setTimeout(updateFloatingCart, 700);
    }, true);
  })();

  } catch(e) { console.error(e); }
})();
})();
